import { render, staticRenderFns } from "./content-layout.vue?vue&type=template&id=783e8d7d&"
import script from "./content-layout.vue?vue&type=script&lang=ts&"
export * from "./content-layout.vue?vue&type=script&lang=ts&"
import style0 from "./content-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports